// extracted by mini-css-extract-plugin
export default {"cards":"cards___J1TFp","card":"card___fKIb4","pointer":"pointer___D8WTj","img":"img___povFc","title":"title___U7Xhu"};